module.exports = __webpack_public_path__ + "static/media/delivery.79158ebe.png";